<template>
  <div id="app">
    <div v-html="styleOverrides()"></div>
    <b-navbar id="nav">
      <b-navbar-brand :href="brand.urls.root">
        <img :src="brand.images.logo" height="50">
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <div v-if="this.$store.state.isVerified">
        <router-link to="/logout">
        <b-button
          variant="primary"
          class="btn-md logout"
        >
          Logout
        </b-button>
        </router-link>
        </div>
      </b-navbar-nav>
    </b-navbar>
    <b-container class="main">
      <router-view >
        <template
          v-slot:howItWorksContent
          v-bind:howItWorks="get(brand, 'content.howItWorksSection.howItWorks')"
          v-if="get(brand, 'content.howItWorksSection.howItWorks.content')">
          {{brand.content.howItWorksSection.howItWorks.content}}
        </template>
        <template
          v-slot:authorizedAgentContent
          v-bind:authorizedAgent="get(brand, 'content.howItWorksSection.authorizedAgent')"
          v-if="get(brand, 'content.howItWorksSection.authorizedAgent.content')">
          {{brand.content.howItWorksSection.authorizedAgent.content}}
        </template>
      </router-view>
    </b-container>
    <div class="container-fluid container-full footer-cta">
      <div class="row">
        <div class="col-sm-12">
          <p v-if="get(brand, 'content.footerCtaContent')" v-html="substitute(brand.content.footerCtaContent)" />
          <p v-else>
            Users with disabilities (and any other users) who wish to make data deletion requests, data portability
            requests, information disclosure requests, opt-out requests and/or do not call requests can also contact us by
            emailing us at: <a :href="'mailto:' + brand.contactInfo.consumerInquiriesEmail">{{brand.contactInfo.consumerInquiriesEmail}}</a>; calling
            us at {{brand.contactInfo.supportNumber}}; or sending US mail to: {{brand.contactInfo.address}}.
            <br><br>
            <a :href="brand.urls.privacyPolicy"><b>Privacy Policy</b></a>
          </p>
        </div>
      </div>
    </div>
    <footer class="container-fluid dms">
      <div class="extra-padding">
        <div class="row" v-if="get(brand, 'socialMediaLinks.length', 0) > 0">
          <div id="follow" class="col-md-6 dms-top-footer">
            <p class="lead primary-font-color">{{brand.socialMediaLinksHeader}}</p>
            <a
              :href="social.link"
              target="_blank"
              rel="nofollow"
              v-for="social in brand.socialMediaLinks"
              v-bind:key="social.type">
              <img :src="social.image" :alt="social.type + ' icon'">
            </a>
          </div>
          <div class="col-xs-12 col-md-6 dms-top-footer">
          </div>
        </div>
        <div class="row" v-if="get(brand, 'footerLinks.length', 0) > 0">
          <div class="col-sm-6 col-md-3" v-for="footerGroup in brand.footerLinks" v-bind:key="footerGroup[0].header">
            <span v-for="footer in footerGroup" v-bind:key="footer.header + '-section'">
              <h5 class="h5-footer">
                <a :href="footer.headerLink">{{footer.header}}</a>
              </h5>
              <a :href="sub.link" v-for="sub in footer.sublinks" v-bind:key="sub.display">
                {{sub.display}}
              </a>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 d-sm-none d-md-block"></div>
          <div class="col-lg-8 col-sm-12 text-center">
            <p v-if="get(brand, 'content.copyrightMessage')" class="copyright source" v-html="brand.content.copyrightMessage"/>
            <p v-else class="copyright source">© {{new Date().getFullYear()}} <span v-html="brand.contactInfo.companyNameFull"/>. All Rights Reserved. {{brand.contactInfo.companyName}} and its logos are trademarks or registered trademarks of <span v-html="brand.contactInfo.companyNameFull"/>. All other company and product names referenced herein are the property of their respective&nbsp;owners.</p>
          </div>
          <div class="col-lg-2 d-sm-none d-md-block"></div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import brandVariables from './mixins/brandVariables.js'
import helperFunctions from './mixins/helperFunctions.js'
export default {
  mixins: [ brandVariables, helperFunctions ],
  mounted () {
  },
  methods: {
    styleOverrides () {
      // this is nasty, but only way for it to work in ie 10
      return `
      <style>
      #app .btn-primary {
        background: ${this.brand.colors.primaryButtonBackground};
      }
      #app footer.dms {
        background: ${this.brand.colors.footerBackgroundColor};

      }
      #app footer.dms .primary-font-color {
        color: ${this.brand.colors.primaryButtonBackground};
      }
      #app .footer-cta {
        background: ${this.brand.colors.primaryButtonBackground};
      }
      #nav {
        background: ${this.brand.colors.navBackground};
      }
      #nav a{
        color: ${this.brand.colors.primaryFontColor};
      }
      #app footer.dms h5 a{
        color: ${this.brand.colors.h5Color};
      }
      #app footer.dms a{
        color: ${this.brand.colors.primaryButtonBackground};
      }
      #app .form-control:focus {
        border-color: ${this.brand.colors.primaryButtonBackground};
        box-shadow: 0 0 3px 0 ${this.brand.colors.primaryButtonBackground};
      }
      </style>
      `
    }
  },
  computed: {
  }
}
</script>
<style lang="less">
html {

}
#app {
  .btn-primary {
    background: #0082ca; // primaryButtonBackground
    border: #56a7da;
    &:disabled, &.disabled {
      opacity: 0.35;
    }
  }
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; // primaryFontColor
  .how-it-works {
    text-align: left;
    margin-top: 40px;
  }
  .main {
    min-height: 400px;
  }
  footer.dms {
    background: #000; // footerBackgroundColor
    text-align: left;
    padding: 80px 0;
    font-size: 16px;
    letter-spacing: .5px;

    div {
      div {
        margin: 10px 0 30px;
      }
    }
    .extra-padding {
      padding-left: 5%;
      padding-right: 5%;
      width: 100%;
    }
    h5 {
      color: #FFF; // h5Color
      font-weight: 600;
      font-size: 1.1em;
      text-transform: uppercase;
      letter-spacing: 3px;
      margin: 10px 0;
      a {
        color: #FFF; // h5Color
      }
    }
    .dms-top-footer {
      margin-top: 10px;
      margin-bottom: 30px;
      a {
        margin-right: 25px;
        float: left;
        display: block;
      }
    }
    .primary-font-color {
      color: #0082ca; // primaryButtonBackground
    }
    a {
      color: #0082ca; // primaryButtonBackground
      display: block;
    }
    .copyright {
      color: #fff;
      margin-top: 20px;
      width: 100%;
      display: block;
      font-size: 13px;
    }
  }
  .footer-cta {
    margin-top: 30px;
    background: #0082ca; // primaryButtonBackground
    color: #FFFFFF;
    .row {
      padding: 30px 0;
      p {
        margin-bottom: 0;
      }
      a {
        color: #FFFFFF;
      }
    }
    .btn {
      margin-top: 20px;
      min-width: 50%;
    }
  }
  footer {
    font-size: 14px;
  }
}
#nav {
  background: rgba(0,130,202,.7); // navBackgroundColor
  margin-bottom: 30px;
  a {
    font-weight: bold;
    color: #2c3e50; // primaryFontColor
    img {
      padding-left: 60px;
    }
    &.router-link-exact-active {
      color: #42b983;
    }
  }
  .logout {
    float: right;
    width: 100px;
    display: block;
    margin-right: 60px;
  }
}
</style>
